<template>
    <div class="size-full rounded-lg border flex flex-col items-center p-[12px]">
          <div class="w-full"><h2 class="flex items-center gap-x-2">Repartition par origine <Info :size="15" strokeWidth="1.3"/></h2></div>
          <div class="grow w-full mt-[10px] flex flex-col items-center justify-between">

            <div class="flex items-center h-[190px] w-[95%] mx-auto gap-x-[6px]">
              <apexchart type="pie" :options="options" :series="series" width="100%" height="190px"></apexchart>
            </div>

            <div class="flex gap-x-[16px] items-center mt-[16px]">
              <div class="flex items-center gap-x-[8px]">
                  <div class="size-4 rounded-sm bg-[#3d82fb]"/> 
                  <span>{{ series[0] }}</span>
                  <span>Locaux</span>
                </div>
                <div class="flex items-center gap-x-[8px]">
                  <div class="size-4 rounded-sm bg-[#fa9932]"/> 
                  <span>{{ series[1] }}</span>
                  <span>Expatriés</span>
                </div>
            </div>

          </div>
    </div>
</template>
<script>
import {Info} from 'lucide-vue-next';
export default {
    name: "RangeOrigin",
    components:{
        Info
    },
    props:['serie'],
    mounted(){
        this.series = this.serie
    },
    data(){
        return {
            series:[],
            options: {
                chart: {
                    type: 'pie',
                    width: "auto",
                    toolbar: {  
                        show: false
                    },
                },
                labels: ['Locaux','Expatriés'],
                colors: ['#3d82fb','#f4405f'],
                dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:false
                },
            }
        }
    }
}
</script>